import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { DecimalPipe } from '@angular/common';
import { Selectors as ProfileSelectors } from 'features/profiles-state/+state/profiles-state.state';
import { map } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import _isNumber from 'lodash-es/isNumber';

@UntilDestroy()
@Pipe({
  name: 'cmNumber',
})
export class NumberLocalePipe implements PipeTransform, OnDestroy {
  locale = 'fr-CA';
  constructor(private store: Store<any>) {
    this.store
      .select(ProfileSelectors.paymentCurrency)
      .pipe(
        map((currency) => {
          switch (currency) {
            case 'usd':
              this.locale = 'en';
              break;
            case 'eur':
            default:
              this.locale = 'fr-CA';
          }
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
  transform(number = 0) {
    if (!_isNumber(number)) {
      return number;
    }
    return new DecimalPipe(this.locale).transform(number, '1.0-2');
  }
  ngOnDestroy() {}
}
